/** Escape text for RTF (ASCII + Unicode via \\uN?). */
function rtfEscape(value) {
  let out = '';
  const text = String(value ?? '');
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i);
    if (code === 92) out += '\\\\';
    else if (code === 123) out += '\\{';
    else if (code === 125) out += '\\}';
    else if (code === 10 || code === 13) out += '\\line ';
    else if (code > 127) {
      const signed = code > 32767 ? code - 65536 : code;
      out += `\\u${signed}?`;
    } else out += text[i];
  }
  return out;
}

function isEmptyRow(row, headers) {
  if (!row || typeof row !== 'object') return true;
  return !headers.some((h) => {
    const v = row[h];
    return v !== undefined && v !== null && String(v).trim() !== '';
  });
}

/**
 * Build a Word-compatible RTF document (opens in Word, LibreOffice, Google Docs).
 */
export function buildRtfFromRows(title, headers, rows) {
  const dataRows = (rows || []).filter((row) => !isEmptyRow(row, headers));
  const colCount = Math.max(headers.length, 1);
  const tableWidth = 9360; // ~6.5in in twips
  const cellStep = Math.floor(tableWidth / colCount);
  const cellDefs = headers.map((_, i) => `\\cellx${(i + 1) * cellStep}`).join('');

  let rtf = '{\\rtf1\\ansi\\ansicpg1252\\deff0\\nouicompat\n';
  rtf += '{\\fonttbl{\\f0\\fnil\\fcharset0 Arial;}}\n';
  rtf += '\\viewkind4\\uc1\n';
  rtf += `\\pard\\sa200\\b\\f0\\fs28 ${rtfEscape(title)}\\b0\\par\\par\n`;

  const writeRow = (cells, bold = false) => {
    rtf += `\\trowd\\trgaph108\\trleft-108${cellDefs}\n`;
    cells.forEach((cell) => {
      rtf += `\\pard\\intbl${bold ? '\\b' : ''} ${rtfEscape(cell)}${bold ? '\\b0' : ''}\\cell `;
    });
    rtf += '\\row\n';
  };

  writeRow(headers, true);
  dataRows.forEach((row) => {
    writeRow(
      headers.map((h) => row[h]),
      false
    );
  });

  rtf += '}';
  return rtf;
}

export function createDocBlob(title, headers, rows) {
  const rtf = buildRtfFromRows(title, headers, rows);
  return new Blob([rtf], { type: 'application/rtf' });
}

/** File extension for export type (DOC button saves Word-compatible RTF). */
export function getExportExtension(fileType) {
  return fileType === 'doc' ? 'rtf' : fileType;
}
